import { chain } from 'lodash';

import { BillingStatusType } from '~globals/types/enums';
import {
  BillingItemCompanyBase,
  BillingItemCompanyType,
} from '~services/billingItem/types';
import { BILLING_STATUS_DESCRIPTIONS } from '~constants/billingStatusDescription';

export const getCompanyToBillingItemId = (
  currentCompany: BillingItemCompanyBase,
): string => {
  let currentId = currentCompany.companyId ?? '';

  if (currentCompany.giverCompanyId) {
    currentId = currentCompany.giverCompanyId;
  }

  if (currentCompany.companyIntegrationStoreId) {
    currentId = currentCompany.companyIntegrationStoreId;
  }

  return currentId;
};

export const getCompanyToBillingItemType = (
  currentCompany: BillingItemCompanyBase,
): BillingItemCompanyType => {
  let currentType: BillingItemCompanyType = 'company';

  if (currentCompany.giverCompanyId) {
    currentType = 'giver';
  }

  if (currentCompany.companyIntegrationStoreId) {
    currentType = 'integration';
  }

  return currentType;
};

export const getCompanyToBillingItemTextType = (
  currentType: BillingItemCompanyType,
): string => {
  let output = 'Compañía';

  if (currentType === 'giver') output = 'Dador de Carga';

  if (currentType === 'integration') output = 'Integración';

  return output;
};

export const getBillingStatusDescription = (
  billingStatusType: BillingStatusType,
): string =>
  chain(BILLING_STATUS_DESCRIPTIONS)
    .find({ billingStatusType })
    .get('description', '')
    .value();
